/* --- init watchdog (added 2026-09-03) --------------------------------------
   The initialiser below marks itself started (data-cnc-cfg-init="1") long
   before it binds any handlers. If it throws in between, every control on the
   configurator is left dead - including the "Start over" button a customer
   would use to recover - and the second copy of this script bails on the flag.
   Registered here, ahead of the initialiser, so it survives that failure. */
(function () {
  window.setTimeout(function () {
    var root = document.querySelector('[data-cnc-cfg]');
    if (!root) return;
    if (root.dataset.cncCfgInit !== '1') return;   /* never started */
    if (root.dataset.cncCfgReady === '1') return;  /* finished cleanly */

    /* Started and died. Release the flag so any later copy can try again. */
    root.dataset.cncCfgInit = '';

    /* Make the recovery button work on its own. */
    var saveKey = 'cf_cnc_config_v1:' + (root.getAttribute('data-product-id') || location.pathname);
    var clearBtn = root.querySelector('[data-cnc-clear-saved]');
    if (clearBtn) {
      clearBtn.removeAttribute('hidden');
      clearBtn.addEventListener('click', function () {
        try { window.localStorage.removeItem(saveKey); } catch (e) {}
        location.reload();
      });
    }
    var statusEl = root.querySelector('[data-cnc-save-status]');
    if (statusEl) {
      statusEl.textContent = 'This configurator did not load correctly. Press \u201cStart over\u201d, or call (336) 887-3101 and we will build the panel with you.';
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cnc_config_init_failed',
      page_path: location.pathname,
      cnc_product_id: root.getAttribute('data-product-id') || ''
    });
  }, 1500);
})();

/* ============================================================
   CNC Configurator
   Scope:
     - Step 1: Material Family (guided) OR Advanced direct vinyl line picker
     - Step 2: Texture/Finish — Standard guided flow only
     - Step 3: Color — guided finish group OR direct material OR advanced line
     - Step 4: Thread — Match Material / Contrast Stitch / Custom Thread Color
     - Step 5: Foam — 3/8" (default) or 1/4", no pricing effect
     - Step 6: Quantity + Notes + optional Custom Material Request
     - Two mutually exclusive paths: "guided" | "advanced"
     - Review: still disabled, no wiring.
   Catalog data:
     - <script data-cnc-catalog>          — guided catalog (Phase 4/5)
     - <script data-cnc-advanced-catalog> — advanced catalog (Phase 6)
     - <script data-cnc-thread-catalog>   — thread catalog (Phase 7)
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-cnc-cfg]');
  if (!root) return;

  /* Batch 7A: guard against double-initialization. cnc-configurator.js is
     included both globally (layout/theme.liquid) and section-scoped
     (sections/cnc-configurator.liquid), so this IIFE can run twice on one
     page. Without this guard, every cart-add handler binds twice and a single
     CTA click fires two /cart/add.js calls (double-add). Key the flag on the
     root element so it persists across both script executions. */
  if (root.dataset.cncCfgInit === '1') return;
  root.dataset.cncCfgInit = '1';

  /* ---------- Config ---------- */
  var basePrice = parseFloat(root.getAttribute('data-base-price'));
  if (isNaN(basePrice)) basePrice = 0;
  var currency = root.getAttribute('data-currency') || '$';

  /* ---------- Variant map (Material → variant_id, price) ----------
     Populated by sections/cnc-configurator.liquid from product.variants.
     Used by syncVariantId() to point the cart-add form at the right
     priced variant when the customer picks a Material. This is what
     makes Stay Cool / Marine Suede actually charge correctly at
     checkout — the price lives in the Shopify variant, not in JS. */
  var variantMap = {};
  var variantMapEl = root.querySelector('script[data-cnc-variant-map]');
  if (variantMapEl) {
    try { variantMap = JSON.parse(variantMapEl.textContent); } catch (e) {}
  }
  function syncVariantId() {
    var key = state.material;
    if (!key) return;
    var entry = variantMap[key];
    if (!entry) return;
    var input = root.querySelector('[data-cnc-form] input[name="id"]');
    if (input) input.value = entry.id;
    /* Update basePrice so the displayed total reflects the variant we're
       actually adding to cart. Upcharge is now baked into variant price,
       so state.upcharge stays 0 to avoid double-counting. */
    var p = parseFloat(entry.price);
    if (!isNaN(p)) basePrice = p;
  }

  /* ---------- Catalogs (from embedded JSON) ---------- */
  var catalog = {};
  var catalogEl = root.querySelector('script[data-cnc-catalog]');
  if (catalogEl) {
    try { catalog = JSON.parse(catalogEl.textContent); }
    catch (e) { catalog = {}; }
  }
  var advancedCatalog = [];
  var advCatEl = root.querySelector('script[data-cnc-advanced-catalog]');
  if (advCatEl) {
    try { advancedCatalog = JSON.parse(advCatEl.textContent); }
    catch (e) { advancedCatalog = []; }
  }
  var threadCatalog = { contrast: [], custom: [] };
  var threadCatEl = root.querySelector('script[data-cnc-thread-catalog]');
  if (threadCatEl) {
    try { threadCatalog = JSON.parse(threadCatEl.textContent); }
    catch (e) { threadCatalog = { contrast: [], custom: [] }; }
  }
  var vinylMap = {};
  var vinylMapEl = root.querySelector('script[data-cnc-vinyl-map]');
  if (vinylMapEl) {
    try { vinylMap = JSON.parse(vinylMapEl.textContent); }
    catch (e) { vinylMap = {}; }
  }
  /* Color-agnostic matching-spool product (Batch 7A). CF matches the spool
     color to the panel BY EYE, so this resolves to ONE variant regardless of
     the stitch choice. Empty/missing → upsell stays hidden (safe no-op). */
  var cncMatchSpool = null;
  var matchSpoolEl = root.querySelector('script[data-cnc-match-spool]');
  if (matchSpoolEl) {
    try {
      var _ms = JSON.parse(matchSpoolEl.textContent) || null;
      if (_ms && _ms.variant_id) cncMatchSpool = _ms;
    } catch (e) { cncMatchSpool = null; }
  }

  /* ---------- State ----------
     Two mutually exclusive paths live in one state object. Only one
     subset is ever "live" at a time, driven by state.mode. The setMode()
     helper is the only place that flips modes, and it always clears the
     outgoing path's selections before switching. */
  var state = {
    mode: 'guided',                                 /* "guided" | "advanced" */
    /* guided path */
    material: null, materialLabel: null, upcharge: 0,
    finish:   null, finishLabel:   null,
    color:    null, colorLabel:    null,
    /* advanced path */
    advancedLine:         null, advancedLineLabel:   null, advancedLineUpcharge: 0,
    advancedColor:        null, advancedColorLabel:  null,
    /* thread (shared across modes; independent of material/color) */
    threadStyle:       'match-material', threadStyleLabel: 'Match Material',
    threadColor:       null, threadColorLabel: null, threadColorHex: null,
    /* foam (Phase 8) — default 3/8"; never affects price */
    foam: '3-8-sew-foam', foamLabel: '3/8" Sew Foam',
    /* quantity / notes / custom request (Phase 8) */
    qty: 1,
    notes: '',
    customRequest: '',
    /* Thread upsell — default OFF; user can opt in. */
    threadUpsellWanted: false,
    /* Vinyl upsell — default ON; user can opt out. When OFF, no vinyl
       line item is added to cart regardless of mapping availability. */
    vinylUpsellWanted: false
  };

  /* ---------- Automatic save / resume ----------
     Only catalog choice IDs and quantities are stored. Customer-entered
     notes and custom requests are intentionally excluded because they may
     contain personal or project-sensitive information. Labels, prices,
     upcharges and variant IDs always resolve fresh from the live page. */
  var saveStatusEl = root.querySelector('[data-cnc-save-status]');
  var clearSavedEl = root.querySelector('[data-cnc-clear-saved]');
  var saveVersion = 1;
  var saveLifetimeMs = 30 * 24 * 60 * 60 * 1000;
  var saveKey = 'cf_cnc_config_v1:' + (root.getAttribute('data-product-id') || location.pathname);
  var restoreComplete = false;

  function fireConfiguratorEvent(name) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      page_path: location.pathname,
      cnc_product_id: root.getAttribute('data-product-id') || ''
    });
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, {
        transport_type: 'beacon',
        page_path: location.pathname,
        cnc_product_id: root.getAttribute('data-product-id') || ''
      });
    }
  }

  function removeSavedConfiguration(announce) {
    try { window.localStorage.removeItem(saveKey); } catch (e) {}
    if (clearSavedEl) clearSavedEl.setAttribute('hidden', '');
    if (announce && saveStatusEl) saveStatusEl.textContent = 'Saved choices cleared. Starting over…';
  }

  function persistConfiguration() {
    if (!restoreComplete || !hasAnyMaterialSelected()) return;
    var payload = {
      version: saveVersion,
      productId: root.getAttribute('data-product-id') || '',
      expiresAt: Date.now() + saveLifetimeMs,
      mode: state.mode,
      material: state.material,
      finish: state.finish,
      color: state.color,
      advancedLine: state.advancedLine,
      advancedColor: state.advancedColor,
      threadStyle: state.threadStyle,
      threadColor: state.threadColor,
      foam: state.foam,
      qty: Math.max(1, Math.min(99, parseInt(state.qty, 10) || 1)),
      vinylUpsellWanted: !!state.vinylUpsellWanted,
      threadUpsellWanted: !!state.threadUpsellWanted,
      yardage: getYardage()
    };
    try {
      window.localStorage.setItem(saveKey, JSON.stringify(payload));
      if (clearSavedEl) clearSavedEl.removeAttribute('hidden');
      if (saveStatusEl && saveStatusEl.textContent.indexOf('restored') === -1) {
        saveStatusEl.textContent = 'Your choices are saved automatically on this device.';
      }
    } catch (e) {
      if (saveStatusEl) saveStatusEl.textContent = 'Your choices will stay on this page, but this browser blocked automatic saving.';
    }
  }

  if (clearSavedEl) {
    clearSavedEl.addEventListener('click', function () {
      removeSavedConfiguration(true);
      fireConfiguratorEvent('cnc_config_cleared');
      window.setTimeout(function () { location.reload(); }, 150);
    });
  }

  /* ---------- Elements ---------- */
  var perEl       = root.querySelector('[data-price-per-panel]');
  var miniPriceEls = root.querySelectorAll('[data-cnc-mini-price]'); /* B4A: compact mobile sticky preview price mirrors */
  var deltaEl     = root.querySelector('[data-price-delta]');
  var sumPriceEl  = root.querySelector('[data-summary="price"]');
  var sumMatEl    = root.querySelector('[data-summary="material"]');
  var sumFinishEl = root.querySelector('[data-summary="finish"]');
  var sumColorEl  = root.querySelector('[data-summary="color"]');

  var step2 = root.querySelector('[data-step-id="finish"]');
  var step3 = root.querySelector('[data-step-id="color"]');

  var advPanel       = root.querySelector('[data-advanced-panel]');
  var advLineSelect  = root.querySelector('[data-advanced-line-select]');
  var advLineMetaEl  = root.querySelector('[data-advanced-line-meta]');
  var advTriggerWrap = root.querySelector('[data-advanced-trigger]');

  var sumFoamEl    = root.querySelector('[data-summary="foam"]');
  var sumQtyEl     = root.querySelector('[data-summary="qty"]');
  var sumSubEl     = root.querySelector('[data-summary="subtotal"]');
  var subRowEl     = root.querySelector('[data-subtotal-row]');

  var foamTiles    = root.querySelectorAll('[data-foam]');
  var qtyInput     = root.querySelector('[data-qty-input]');
  var notesInput   = root.querySelector('[data-notes-input]');
  var customReqInput = root.querySelector('[data-custom-request-input]');

  var sumThreadEl   = root.querySelector('[data-summary="thread"]');
  var threadDescEl  = root.querySelector('[data-thread-desc]');
  var threadColorGridEl = root.querySelector('[data-thread-color-grid]');
  var threadEmptyEl = root.querySelector('[data-thread-empty]');
  var threadStyleTiles = root.querySelectorAll('[data-thread-style]');

  var finishDescEl  = step2 && step2.querySelector('[data-finish-desc]');
  var finishGridEl  = step2 && step2.querySelector('[data-finish-grid]');
  var finishEmptyEl = step2 && step2.querySelector('[data-finish-empty]');

  var colorDescEl  = step3 && step3.querySelector('[data-color-desc]');
  var colorGridEl  = step3 && step3.querySelector('[data-color-grid]');
  var colorEmptyEl = step3 && step3.querySelector('[data-color-empty]');

  /* Review / ATC / validation elements */
  var reviewListEl  = root.querySelector('[data-review-list]');
  var reviewEmptyEl = root.querySelector('[data-review-empty]');
  var ctaBtnEl      = root.querySelector('[data-cta-add]');
  var ctaHintEl     = root.querySelector('[data-cta-hint]');
  var formQtyEl     = root.querySelector('[data-form-qty]');
  var formPropsEl   = root.querySelector('[data-form-properties]');

  /* Live preview elements */
  var previewBgEl     = root.querySelector('[data-preview-bg]');
  var previewBorderEl = root.querySelector('[data-preview-border]');
  var previewStitchEl = root.querySelector('[data-preview-stitches]');
  var previewCapEl    = root.querySelector('[data-preview-caption]');

  /* Vinyl upsell elements */
  var upsellEl        = root.querySelector('[data-upsell]');
  var upsellDescEl    = root.querySelector('[data-upsell-desc]');
  var upsellYardEl    = root.querySelector('[data-upsell-yardage]');
  var upsellPriceEl   = root.querySelector('[data-upsell-price]');
  var upsellRegEl     = root.querySelector('[data-upsell-reg]');
  var upsellSaveEl    = root.querySelector('[data-upsell-save]');
  var upsellSavedEl   = root.querySelector('[data-upsell-saved]');
  var upsellLineEl    = root.querySelector('[data-upsell-line]');
  var upsellSubEl     = root.querySelector('[data-upsell-subtotal]');
  var upsellCtrlEl    = root.querySelector('[data-upsell-controls]');
  var vinylUpsellChoices = root.querySelectorAll('[data-vinyl-upsell-choice]');

  /* Thread upsell elements */
  var threadUpsellEl        = root.querySelector('[data-thread-upsell]');
  var threadUpsellSubEl     = root.querySelector('[data-thread-upsell-subtext]');
  var threadUpsellChoices   = root.querySelectorAll('[data-thread-upsell-choice]');
  var threadUpsellLineEl    = root.querySelector('[data-thread-upsell-line]');
  var threadUpsellPriceEl   = root.querySelector('[data-thread-upsell-price]');

  /* Estimated total elements */
  var estimatedTotalEl = root.querySelector('[data-estimated-total]');
  var estPanelRowEl    = root.querySelector('[data-est-panel-row]');
  var estPanelEl       = root.querySelector('[data-est-panel]');
  var estVinylRowEl    = root.querySelector('[data-est-vinyl-row]');
  var estVinylLabelEl  = root.querySelector('[data-est-vinyl-label]');
  var estVinylEl       = root.querySelector('[data-est-vinyl]');
  var estThreadRowEl   = root.querySelector('[data-est-thread-row]');
  var estThreadLabelEl = root.querySelector('[data-est-thread-label]');
  var estThreadEl      = root.querySelector('[data-est-thread]');
  var estTotalEl       = root.querySelector('[data-est-total]');

  /* Quantity guidance tiles */
  var qtyPresetTiles = root.querySelectorAll('[data-qty-preset]');

  /* Mobile guided progression. A material choice used to update the next
     step below the fold without moving the viewport, which made the control
     feel broken. Keep focus semantics intact, announce the transition, and
     bring the next required step into view on phones/tablets only. */
  var mobileFlowMedia = window.matchMedia('(max-width: 899px)');
  var flowStatusEl = document.createElement('div');
  flowStatusEl.className = 'visually-hidden';
  flowStatusEl.setAttribute('role', 'status');
  flowStatusEl.setAttribute('aria-live', 'polite');
  flowStatusEl.setAttribute('aria-atomic', 'true');
  root.appendChild(flowStatusEl);

  /* Was mobile-only. Now runs at every width: on desktop the customer used to
     select a material and get no cue at all that anything came next.
     Desktop scrolls only when the next step isn't already usefully on screen,
     so a large monitor doesn't get yanked around. (2026-09-03) */
  function stepNeedsScroll(target) {
    var r = target.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.top < 0) return true;
    if (r.top > vh * 0.85) return true;
    var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    return visible < Math.min(r.height, vh * 0.35);
  }

  var suppressFlow = false; /* set during programmatic preselect on load */
  function renumberSteps() {
    var steps = root.querySelectorAll('.cnc-cfg__step[data-step]');
    var n = 0;
    Array.prototype.forEach.call(steps, function (st) {
      if (st.hasAttribute('hidden')) return;
      var idx = st.querySelector('.cnc-cfg__step-index');
      n += 1;
      if (idx) idx.textContent = String(n);
    });
  }
  function advanceMobileFlow(stepId, selectionLabel, keyboardActivation) {
    if (suppressFlow) return;
    var target = root.querySelector('[data-step-id="' + stepId + '"]');
    if (!target || target.hasAttribute('hidden')) return;
    var heading = target.querySelector('.cnc-cfg__step-title');
    var nextLabel = heading ? heading.textContent.trim() : 'the next step';
    flowStatusEl.textContent = selectionLabel + ' selected. Next: ' + nextLabel + '.';

    window.setTimeout(function () {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.classList.add('cnc-cfg__step--arrived');
      if (mobileFlowMedia.matches || stepNeedsScroll(target)) {
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }

      /* Keyboard activation should move focus with the visual context.
         Pointer/touch activation keeps focus on the selected control so
         changing a choice remains predictable. */
      if (keyboardActivation && heading) {
        heading.setAttribute('tabindex', '-1');
        try { heading.focus({ preventScroll: true }); }
        catch (e) { heading.focus(); }
      }

      window.setTimeout(function () {
        target.classList.remove('cnc-cfg__step--arrived');
      }, 1200);
    }, 80);
  }

  /* ---------- Formatting ---------- */
  function fmt(n) { return currency + n.toFixed(2); }

  /* ---------- Mode-aware accessors ---------- */
  function currentUpcharge() {
    return state.mode === 'advanced' ? (state.advancedLineUpcharge || 0) : (state.upcharge || 0);
  }
  function currentMaterialLabel() {
    return state.mode === 'advanced' ? state.advancedLineLabel : state.materialLabel;
  }
  function currentColorLabel() {
    return state.mode === 'advanced' ? state.advancedColorLabel : state.colorLabel;
  }
  function hasAnyMaterialSelected() {
    return state.mode === 'advanced' ? !!state.advancedLine : !!state.material;
  }

  /* ---------- Price + summary ---------- */
  function updatePriceDisplay() {
    var upcharge = currentUpcharge();
    var perPanel = basePrice + upcharge;
    var qty = Math.max(1, parseInt(state.qty, 10) || 1);
    var subtotal = perPanel * qty;
    if (perEl)      perEl.textContent = fmt(perPanel);
    for (var mpi = 0; mpi < miniPriceEls.length; mpi++) miniPriceEls[mpi].textContent = fmt(perPanel); /* B4A */
    if (sumPriceEl) sumPriceEl.textContent = fmt(perPanel);
    if (sumSubEl)   sumSubEl.textContent = fmt(subtotal);
    if (subRowEl) {
      if (qty > 1) subRowEl.removeAttribute('hidden');
      else         subRowEl.setAttribute('hidden', '');
    }
    if (!deltaEl) return;

    var label = currentMaterialLabel() || 'material';
    if (upcharge > 0) {
      deltaEl.textContent = 'Base ' + fmt(basePrice) + ' + ' + fmt(upcharge) + ' ' + label + ' upcharge';
      deltaEl.classList.add('is-upcharge');
    } else if (hasAnyMaterialSelected()) {
      deltaEl.textContent = (state.mode === 'advanced')
        ? 'Advanced selection \u00b7 no upcharge'
        : 'Standard material, no upcharge';
      deltaEl.classList.remove('is-upcharge');
    } else {
      deltaEl.textContent = (state.mode === 'advanced')
        ? 'Advanced mode \u00b7 select a vinyl line'
        : 'Base panel price shown above. Material upgrades are shown before checkout.';
      deltaEl.classList.remove('is-upcharge');
    }
  }

  function updateSummary() {
    if (sumMatEl)    sumMatEl.textContent    = currentMaterialLabel() || '—';
    /* Finish only meaningful in guided Standard flow; hide the summary
       row entirely for materials/modes without finish groups. */
    if (sumFinishEl) {
      var finishRow = sumFinishEl.closest ? sumFinishEl.closest('.cnc-cfg__summary-row') : null;
      var entryFG = state.material && catalog[state.material];
      var hasFinishes = !!(entryFG && entryFG.finishes && entryFG.finishes.length);
      var showFinishRow = state.mode === 'guided' && hasFinishes;
      if (finishRow) {
        if (showFinishRow) finishRow.removeAttribute('hidden');
        else finishRow.setAttribute('hidden', '');
      }
      sumFinishEl.textContent = (showFinishRow && state.finishLabel) ? state.finishLabel : '—';
    }
    if (sumColorEl)  sumColorEl.textContent  = currentColorLabel() || '—';
    if (sumThreadEl) sumThreadEl.textContent = threadSummaryText();
    if (sumFoamEl)   sumFoamEl.textContent   = state.foamLabel || '—';
    if (sumQtyEl)    sumQtyEl.textContent    = String(state.qty || 1);
  }

  function threadSummaryText() {
    if (!state.threadStyle) return '—';
    return state.threadColorLabel || '—';
  }

  /* ---------- Step 2 (Finish) render ---------- */
  function renderFinishesForMaterial() {
    if (!step2 || !finishGridEl) return;
    finishGridEl.innerHTML = '';

    /* Advanced mode: Step 2 is never used. */
    if (state.mode === 'advanced') {
      step2.classList.remove('cnc-cfg__step--active');
      if (finishDescEl)  finishDescEl.textContent  = 'Not applicable in advanced mode.';
      if (finishEmptyEl) { finishEmptyEl.textContent = 'Advanced direct-catalog mode bypasses the guided finish step.'; finishEmptyEl.style.display = ''; }
      return;
    }

    var entry = state.material && catalog[state.material];
    var finishes = entry && entry.finishes ? entry.finishes : [];
    var directColors = entry && entry.colors ? entry.colors : null;

    if (!state.material) {
      step2.classList.remove('cnc-cfg__step--active');
      step2.removeAttribute('hidden');
      if (finishDescEl)  finishDescEl.textContent  = 'Pick a material first to see finish options.';
      if (finishEmptyEl) { finishEmptyEl.textContent = 'Select a material above to see available finishes.'; finishEmptyEl.style.display = ''; }
      return;
    }

    /* Direct-color materials (Stay Cool, Marine Suede) and any other
       material without finish groups: hide Step 2 entirely so the UI
       doesn't show an empty / "not applicable" shell. */
    if (finishes.length === 0) {
      step2.classList.remove('cnc-cfg__step--active');
      step2.setAttribute('hidden', '');
      return;
    }

    /* Active state — Standard Marine Vinyl */
    step2.removeAttribute('hidden');
    step2.classList.add('cnc-cfg__step--active');
    if (finishDescEl)  finishDescEl.textContent  = 'Choose a texture. Colors will filter to that group only.';
    if (finishEmptyEl) finishEmptyEl.style.display = 'none';

    for (var i = 0; i < finishes.length; i++) {
      var f = finishes[i];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cnc-cfg__tile cnc-cfg__tile--material';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('data-finish', f.id);
      btn.setAttribute('data-finish-label', f.label);
      btn.innerHTML =
        '<span class="cnc-cfg__tile-swatch"></span>' +
        '<span class="cnc-cfg__tile-label">' + f.label + '</span>' +
        '<span class="cnc-cfg__tile-meta">' + (f.desc || '') + '</span>';
      btn.addEventListener('click', onFinishClick);
      finishGridEl.appendChild(btn);
    }
  }

  var _renderFinishesForMaterial = renderFinishesForMaterial;
  renderFinishesForMaterial = function () { _renderFinishesForMaterial(); renumberSteps(); };

  function onFinishClick(e) {
    var tile = e.currentTarget;
    var allTiles = finishGridEl.querySelectorAll('[data-finish]');
    Array.prototype.forEach.call(allTiles, function (t) { t.setAttribute('aria-checked', 'false'); });
    tile.setAttribute('aria-checked', 'true');

    var selectedFinish = tile.getAttribute('data-finish');
    if (state.finish === selectedFinish) {
      advanceMobileFlow('color', state.finishLabel, e.detail === 0);
      return;
    }

    state.finish      = selectedFinish;
    state.finishLabel = tile.getAttribute('data-finish-label');
    /* New finish resets the color selection */
    state.color = null; state.colorLabel = null;

    renderColorsForFinish();
    /* A cleared color may leave Match Material stranded — resync it */
    if (state.threadStyle === 'match-material') renderThreadColorArea();
    updateSummary();
    advanceMobileFlow('color', state.finishLabel, e.detail === 0);
  }

  /* ---------- Step 3 (Color) render ----------
     Four possible sources for the color list:
       A) Guided mode, material has a finish selected → colors from that group
       B) Guided mode, material has direct colors      → material.colors
       C) Advanced mode, vinyl line selected           → line.colors
       D) None of the above                            → inactive empty state
  */
  function renderColorsForFinish() {
    if (!step3 || !colorGridEl) return;
    colorGridEl.innerHTML = '';

    var colors = null;
    var descText = '';

    if (state.mode === 'advanced') {
      /* C) Advanced vinyl line path */
      var line = findAdvancedLine(state.advancedLine);
      if (line) {
        colors = line.colors || [];
        descText = 'Showing ' + line.label + ' colors.';
      }
    } else {
      var entry = state.material && catalog[state.material];
      var finishes = entry && entry.finishes ? entry.finishes : [];
      var directColors = entry && entry.colors ? entry.colors : null;

      /* A) Finish group path (guided Standard flow) */
      var group = null;
      for (var i = 0; i < finishes.length; i++) {
        if (finishes[i].id === state.finish) { group = finishes[i]; break; }
      }
      if (group) {
        colors = group.colors || [];
        descText = 'Showing ' + group.label + ' colors only.';
      } else if (finishes.length === 0 && directColors && directColors.length) {
        /* B) Direct-color path (Stay Cool / Marine Suede) */
        colors = directColors;
        descText = 'Showing ' + state.materialLabel + ' colors.';
      }
    }

    if (!colors) {
      /* D) Nothing to show yet */
      step3.classList.remove('cnc-cfg__step--active');
      if (colorDescEl) {
        if (state.mode === 'advanced') {
          colorDescEl.textContent = 'Colors appear after you pick a vinyl line.';
        } else if (state.material) {
          colorDescEl.textContent = 'Colors appear after you pick a finish.';
        } else {
          colorDescEl.textContent = 'Colors appear after you pick a material.';
        }
      }
      if (colorEmptyEl) {
        colorEmptyEl.textContent = (state.mode === 'advanced')
          ? 'Pick a vinyl line above to see available colors.'
          : ((state.material) ? 'Pick a finish above to see available colors.' : 'Pick a material above to see available colors.');
        colorEmptyEl.style.display = '';
      }
      return;
    }

    step3.classList.add('cnc-cfg__step--active');
    if (colorDescEl)  colorDescEl.textContent  = descText;
    if (colorEmptyEl) colorEmptyEl.style.display = 'none';
    for (var j = 0; j < colors.length; j++) {
      var c = colors[j];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cnc-cfg__swatch';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('data-color', c.id);
      btn.setAttribute('data-color-label', c.label);
      btn.innerHTML =
        '<span class="cnc-cfg__swatch-chip" style="background:' + c.hex + ';"></span>' +
        '<span class="cnc-cfg__swatch-label">' + c.label + '</span>';
      btn.addEventListener('click', onColorClick);
      colorGridEl.appendChild(btn);
    }
  }

  function onColorClick(e) {
    var btn = e.currentTarget;
    var all = colorGridEl.querySelectorAll('[data-color]');
    Array.prototype.forEach.call(all, function (t) { t.setAttribute('aria-checked', 'false'); });
    btn.setAttribute('aria-checked', 'true');
    var id    = btn.getAttribute('data-color');
    var label = btn.getAttribute('data-color-label');
    if (state.mode === 'advanced') {
      state.advancedColor      = id;
      state.advancedColorLabel = label;
    } else {
      state.color      = id;
      state.colorLabel = label;
    }
    /* Match Material auto-updates when the material color changes */
    if (state.threadStyle === 'match-material') renderThreadColorArea();
    updateSummary();
    advanceMobileFlow('thread', label, e.detail === 0);
  }

  /* ---------- Preset finish (2026-09-16 simplification) ----------
     Material tiles may carry data-preset-finish. When present, the finish
     step is resolved automatically from the guided catalog and Step 2 is
     hidden — the buyer goes straight from material to color. Pricing is
     untouched: the tile's data-material still drives syncVariantId(). */
  function applyPresetFinish(finishId) {
    if (!finishId || !step2 || !finishGridEl) return;
    var ft = finishGridEl.querySelector('[data-finish="' + finishId + '"]');
    if (!ft) return;
    Array.prototype.forEach.call(finishGridEl.querySelectorAll('[data-finish]'), function (t) { t.setAttribute('aria-checked', 'false'); });
    ft.setAttribute('aria-checked', 'true');
    state.finish      = finishId;
    state.finishLabel = ft.getAttribute('data-finish-label');
    step2.classList.remove('cnc-cfg__step--active');
    step2.setAttribute('hidden', '');
    renumberSteps();
  }
  /* Show-all / hide toggle for the secondary material grid */
  (function initShowAll() {
    var btn  = root.querySelector('[data-cnc-show-all]');
    var more = root.querySelector('[data-cnc-more-grid]');
    var hide = root.querySelector('[data-cnc-hide-all]');
    if (!btn || !more) return;
    function open()  { more.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true');  btn.setAttribute('hidden', ''); }
    function close() { more.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); btn.removeAttribute('hidden'); btn.focus(); }
    btn.addEventListener('click', open);
    if (hide) hide.addEventListener('click', close);
    root.cncOpenMore = open;
  })();

  /* ---------- Step 1 (Material) — clears downstream on change ---------- */
  var matTiles = root.querySelectorAll('[data-step-id="material-family"] .cnc-cfg__tile--material[data-material]');
  Array.prototype.forEach.call(matTiles, function (tile) {
    tile.addEventListener('click', function (event) {
      Array.prototype.forEach.call(matTiles, function (t) { t.setAttribute('aria-checked', 'false'); });
      tile.setAttribute('aria-checked', 'true');

      var selectedMaterial = tile.getAttribute('data-material');
      var presetFinish = tile.getAttribute('data-preset-finish') || null;
      if (state.material === selectedMaterial && (!presetFinish || state.finish === presetFinish)) {
        var currentNextStep = step2 && !step2.hasAttribute('hidden') ? 'finish' : 'color';
        advanceMobileFlow(currentNextStep, state.materialLabel, event.detail === 0);
        return;
      }

      state.material      = selectedMaterial;
      state.materialLabel = tile.getAttribute('data-material-label');
      /* Variant carries the upcharge now — zero out state.upcharge so
         updatePriceDisplay doesn't double-count it on top of basePrice. */
      state.upcharge      = 0;
      syncVariantId();

      /* Changing material always clears downstream finish/color selections */
      state.finish = null; state.finishLabel = null;
      state.color  = null; state.colorLabel  = null;

      renderFinishesForMaterial();
      applyPresetFinish(presetFinish);
      renderColorsForFinish();
      if (state.threadStyle === 'match-material') renderThreadColorArea();
      updateSummary();
      updatePriceDisplay();
      var nextStepId = step2 && !step2.hasAttribute('hidden') ? 'finish' : 'color';
      advanceMobileFlow(nextStepId, state.materialLabel, event.detail === 0);
    });
  });

  /* ==================================================================
     Thread step (Phase 7)
     Shared across guided and advanced modes. Does not affect pricing.
     ================================================================== */

  /* Look up the hex of the currently selected material color (either
     the guided color from finish/direct, or the advanced line color).
     Returns null if no color has been picked yet. */
  function currentColorHex() {
    if (state.mode === 'advanced') {
      var line = findAdvancedLine(state.advancedLine);
      if (!line || !state.advancedColor) return null;
      for (var i = 0; i < (line.colors || []).length; i++) {
        if (line.colors[i].id === state.advancedColor) return line.colors[i].hex;
      }
      return null;
    }
    /* Guided path — search the guided catalog for the selected color id */
    var entry = state.material && catalog[state.material];
    if (!entry || !state.color) return null;
    var pools = [];
    if (entry.colors) pools.push(entry.colors);
    if (entry.finishes) {
      for (var j = 0; j < entry.finishes.length; j++) {
        if (entry.finishes[j].colors) pools.push(entry.finishes[j].colors);
      }
    }
    for (var k = 0; k < pools.length; k++) {
      for (var m = 0; m < pools[k].length; m++) {
        if (pools[k][m].id === state.color) return pools[k][m].hex;
      }
    }
    return null;
  }

  /* Parse "#RRGGBB" → [r,g,b] ints. Returns null on bad input. */
  function hexToRgb(hex) {
    if (!hex || hex.charAt(0) !== '#' || hex.length !== 7) return null;
    var r = parseInt(hex.substr(1, 2), 16);
    var g = parseInt(hex.substr(3, 2), 16);
    var b = parseInt(hex.substr(5, 2), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return null;
    return [r, g, b];
  }

  /* Find the thread in the custom palette whose color is closest in
     RGB Euclidean distance to the given target hex. Used for Match Material. */
  function nearestThreadToHex(targetHex) {
    var target = hexToRgb(targetHex);
    var pool = (threadCatalog && threadCatalog.custom) || [];
    if (!target || pool.length === 0) return null;
    var best = null;
    var bestDist = Infinity;
    for (var i = 0; i < pool.length; i++) {
      var p = hexToRgb(pool[i].hex);
      if (!p) continue;
      var dr = target[0] - p[0];
      var dg = target[1] - p[1];
      var db = target[2] - p[2];
      var d = dr * dr + dg * dg + db * db;
      if (d < bestDist) { bestDist = d; best = pool[i]; }
    }
    return best;
  }

  function applyThreadColor(id, label, hex) {
    state.threadColor      = id;
    state.threadColorLabel = label;
    state.threadColorHex   = hex;
  }

  function clearThreadColor() {
    state.threadColor      = null;
    state.threadColorLabel = null;
    state.threadColorHex   = null;
  }

  function renderThreadColorArea() {
    if (!threadColorGridEl) return;
    threadColorGridEl.innerHTML = '';

    if (!state.threadStyle) {
      if (threadEmptyEl) { threadEmptyEl.textContent = 'Pick a thread style above to continue.'; threadEmptyEl.style.display = 'block'; }
      if (threadDescEl)  threadDescEl.textContent   = 'How the stitching reads against your material.';
      return;
    }

    if (state.threadStyle === 'match-material') {
      /* By-eye matching: Carolyn matches the thread to the material by
         eye at the shop. No automatic RGB / color-distance guessing —
         the old nearest-thread algorithm mismatched colors (e.g. a
         charcoal vinyl to a green thread), so NO named thread color is
         selected here. The order simply records "match by eye". */
      clearThreadColor();
      if (threadDescEl)  threadDescEl.textContent   = 'We match the thread by eye at our shop.';
      if (threadEmptyEl) {
        threadEmptyEl.textContent = 'We match the thread by eye at our shop \u2014 no color selection needed.';
        threadEmptyEl.style.display = 'block';
      }
      return;
    }

    /* Contrast Stitch or Custom Thread Color — pick from a pool */
    var pool = (state.threadStyle === 'contrast-stitch')
      ? (threadCatalog.contrast || [])
      : (threadCatalog.custom || []);
    if (state.threadStyle === 'contrast-stitch') {
      if (threadDescEl) threadDescEl.textContent = 'Choose from all 34 stocked thread colors.';
    } else {
      if (threadDescEl) threadDescEl.textContent = 'Choose from all 34 stocked thread colors. Screen colors are approximate.';
    }
    if (threadEmptyEl) threadEmptyEl.style.display = 'none';

    for (var i = 0; i < pool.length; i++) {
      var t = pool[i];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cnc-cfg__swatch';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', state.threadColor === t.id ? 'true' : 'false');
      btn.setAttribute('data-thread-color', t.id);
      btn.setAttribute('data-thread-color-label', t.label);
      btn.setAttribute('data-thread-color-hex', t.hex || '');
      var chip = document.createElement('span');
      chip.className = 'cnc-cfg__swatch-chip';
      if (t.image) {
        var photo = document.createElement('img');
        photo.src = t.image;
        photo.alt = '';
        photo.loading = 'lazy';
        photo.width = 48;
        photo.height = 48;
        photo.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;border-radius:inherit';
        chip.appendChild(photo);
      } else if (t.hex) {
        chip.style.backgroundColor = t.hex;
      }
      var label = document.createElement('span');
      label.className = 'cnc-cfg__swatch-label';
      label.textContent = t.label;
      btn.appendChild(chip);
      btn.appendChild(label);
      btn.addEventListener('click', onThreadColorClick);
      threadColorGridEl.appendChild(btn);
    }
  }

  /* After the thread step, land on the upsell stack if any offer is
     showing (matching vinyl / spool) — otherwise straight to foam.
     Previously the flow scrolled past the upsells (2026-09-16). */
  function afterThreadStep() {
    var stack = root.querySelector('[data-upsell-stack]');
    if (stack && stack.querySelector('.cnc-cfg__upsell:not([hidden])')) return 'upsells';
    return 'foam';
  }

  function onThreadColorClick(e) {
    var btn = e.currentTarget;
    var all = threadColorGridEl.querySelectorAll('[data-thread-color]');
    Array.prototype.forEach.call(all, function (t) { t.setAttribute('aria-checked', 'false'); });
    btn.setAttribute('aria-checked', 'true');
    applyThreadColor(
      btn.getAttribute('data-thread-color'),
      btn.getAttribute('data-thread-color-label'),
      btn.getAttribute('data-thread-color-hex')
    );
    updateSummary();
    advanceMobileFlow(afterThreadStep(), btn.getAttribute('data-thread-color-label'), e.detail === 0);
  }

  function onThreadStyleClick(e) {
    var tile = e.currentTarget;
    Array.prototype.forEach.call(threadStyleTiles, function (t) { t.setAttribute('aria-checked', 'false'); });
    tile.setAttribute('aria-checked', 'true');
    state.threadStyle      = tile.getAttribute('data-thread-style');
    state.threadStyleLabel = tile.getAttribute('data-thread-style-label');
    /* Changing style resets the per-style color selection */
    clearThreadColor();
    renderThreadColorArea();
    updateSummary();
    /* Match Material needs no swatch, so this step is done. Contrast and
       Custom render a colour grid inside THIS step - leave the customer on
       it; the grid appearing is the cue. (2026-09-03) */
    if (state.threadStyle === 'match-material') {
      advanceMobileFlow(afterThreadStep(), state.threadStyleLabel, e.detail === 0);
    }
  }

  /* Bind once; tiles are static in the markup */
  Array.prototype.forEach.call(threadStyleTiles, function (tile) {
    tile.addEventListener('click', onThreadStyleClick);
  });

  /* ==================================================================
     Foam step (Phase 8)
     Default: 3/8" Sew Foam. Does NOT affect pricing.
     ================================================================== */
  function onFoamClick(e) {
    var tile = e.currentTarget;
    Array.prototype.forEach.call(foamTiles, function (t) { t.setAttribute('aria-checked', 'false'); });
    tile.setAttribute('aria-checked', 'true');
    state.foam      = tile.getAttribute('data-foam');
    state.foamLabel = tile.getAttribute('data-foam-label');
    updateSummary();
    advanceMobileFlow('qty-notes', state.foamLabel, e.detail === 0);
  }
  Array.prototype.forEach.call(foamTiles, function (tile) {
    tile.addEventListener('click', onFoamClick);
  });

  /* ==================================================================
     Quantity / Notes / Custom material request (Phase 8)
     Quantity multiplies the per-panel price into a subtotal. Notes and
     the custom material request are passive text — they do not affect
     any selection logic or pricing.
     ================================================================== */
  function onQtyInput() {
    var v = parseInt(qtyInput.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    /* Soft-clamp the visible input so users can't submit 0 or empty */
    if (String(v) !== qtyInput.value) qtyInput.value = String(v);
    state.qty = v;
    updatePriceDisplay();
    updateSummary();
  }
  if (qtyInput) {
    qtyInput.addEventListener('input', function () {
      /* Manual input clears the tile selection — don't fight the user */
      clearQtyTileSelection();
      onQtyInput();
    });
    qtyInput.addEventListener('change', function () {
      clearQtyTileSelection();
      onQtyInput();
    });
  }

  function clearQtyTileSelection() {
    for (var i = 0; i < qtyPresetTiles.length; i++) {
      qtyPresetTiles[i].classList.remove('cnc-cfg__tile--selected');
      qtyPresetTiles[i].setAttribute('aria-checked', 'false');
    }
  }

  /* Quantity guidance tiles set a sensible default; user can still edit. */
  for (var qi = 0; qi < qtyPresetTiles.length; qi++) {
    (function (tile) {
      tile.addEventListener('click', function () {
        var v = parseInt(tile.getAttribute('data-qty-preset'), 10);
        if (isNaN(v) || v < 1) v = 1;
        clearQtyTileSelection();
        tile.classList.add('cnc-cfg__tile--selected');
        tile.setAttribute('aria-checked', 'true');
        if (qtyInput) qtyInput.value = String(v);
        state.qty = v;
        updatePriceDisplay();
        updateSummary();
      });
    })(qtyPresetTiles[qi]);
  }
  if (notesInput) {
    notesInput.addEventListener('input', function () {
      state.notes = notesInput.value;
      updateSummary();
    });
  }
  if (customReqInput) {
    customReqInput.addEventListener('input', function () {
      state.customRequest = customReqInput.value;
      updateSummary();
    });
  }

  /* ==================================================================
     Advanced mode (Phase 6)
     ================================================================== */

  function findAdvancedLine(id) {
    if (!id) return null;
    for (var i = 0; i < advancedCatalog.length; i++) {
      if (advancedCatalog[i].id === id) return advancedCatalog[i];
    }
    return null;
  }

  function clearGuidedSelections() {
    state.material = null; state.materialLabel = null; state.upcharge = 0;
    state.finish   = null; state.finishLabel   = null;
    state.color    = null; state.colorLabel    = null;
    var matTilesAll = root.querySelectorAll('[data-step-id="material-family"] .cnc-cfg__tile--material[data-material]');
    Array.prototype.forEach.call(matTilesAll, function (t) { t.setAttribute('aria-checked', 'false'); });
  }

  function clearAdvancedSelections() {
    state.advancedLine         = null;
    state.advancedLineLabel    = null;
    state.advancedLineUpcharge = 0;
    state.advancedColor        = null;
    state.advancedColorLabel   = null;
    if (advLineSelect) advLineSelect.value = '';
    if (advLineMetaEl) {
      advLineMetaEl.textContent = 'Pick a line to see available colors and upcharge.';
      advLineMetaEl.classList.remove('is-active');
    }
  }

  function setMode(mode) {
    if (mode !== 'guided' && mode !== 'advanced') return;
    if (state.mode === mode) return;

    /* Clear the path we're leaving — guarantees no cross-mode contamination */
    if (mode === 'advanced') {
      clearGuidedSelections();
    } else {
      clearAdvancedSelections();
    }

    state.mode = mode;
    root.setAttribute('data-mode', mode);
    if (advPanel) {
      if (mode === 'advanced') advPanel.removeAttribute('hidden');
      else advPanel.setAttribute('hidden', '');
    }

    renderFinishesForMaterial();
    renderColorsForFinish();
    if (state.threadStyle === 'match-material') renderThreadColorArea();
    updateSummary();
    updatePriceDisplay();
  }

  function populateAdvancedLineSelect() {
    if (!advLineSelect) return;
    /* Preserve the leading placeholder option written in the markup */
    for (var i = 0; i < advancedCatalog.length; i++) {
      var line = advancedCatalog[i];
      var opt = document.createElement('option');
      opt.value = line.id;
      opt.textContent = line.label + '  (+ $' + Number(line.upcharge || 0).toFixed(0) + '/panel)';
      advLineSelect.appendChild(opt);
    }
    advLineSelect.addEventListener('change', onAdvancedLineChange);
  }

  function onAdvancedLineChange() {
    var val = advLineSelect.value;
    /* Any line change resets the advanced color */
    state.advancedColor      = null;
    state.advancedColorLabel = null;

    if (!val) {
      state.advancedLine         = null;
      state.advancedLineLabel    = null;
      state.advancedLineUpcharge = 0;
      if (advLineMetaEl) {
        advLineMetaEl.textContent = 'Pick a line to see available colors and upcharge.';
        advLineMetaEl.classList.remove('is-active');
      }
    } else {
      var line = findAdvancedLine(val);
      if (line) {
        state.advancedLine         = line.id;
        state.advancedLineLabel    = line.label;
        state.advancedLineUpcharge = Number(line.upcharge || 0);
        if (advLineMetaEl) {
          advLineMetaEl.textContent = line.desc + ' \u00b7 + $' + state.advancedLineUpcharge.toFixed(0) + ' per panel';
          advLineMetaEl.classList.add('is-active');
        }
      }
    }

    renderColorsForFinish();
    if (state.threadStyle === 'match-material') renderThreadColorArea();
    updateSummary();
    updatePriceDisplay();
  }

  /* ---------- Advanced catalog trigger + back ---------- */
  var advBtn = root.querySelector('[data-action="advanced-catalog"]');
  if (advBtn) {
    advBtn.addEventListener('click', function (e) {
      e.preventDefault();
      setMode('advanced');
    });
  }
  var advBack = root.querySelector('[data-action="advanced-back"]');
  if (advBack) {
    advBack.addEventListener('click', function (e) {
      e.preventDefault();
      setMode('guided');
    });
  }

  function guidedColorFromSaved(entry, finishId, colorId) {
    if (!entry || !colorId) return null;
    var colors = entry.colors || [];
    if (entry.finishes && entry.finishes.length) {
      colors = [];
      for (var i = 0; i < entry.finishes.length; i++) {
        if (entry.finishes[i].id === finishId) {
          colors = entry.finishes[i].colors || [];
          break;
        }
      }
    }
    for (var j = 0; j < colors.length; j++) {
      if (colors[j].id === colorId) return colors[j];
    }
    return null;
  }

  function threadColorFromSaved(style, colorId) {
    if (!colorId || style === 'match-material') return null;
    var pool = style === 'contrast-stitch'
      ? (threadCatalog.contrast || [])
      : (threadCatalog.custom || []);
    for (var i = 0; i < pool.length; i++) {
      if (pool[i].id === colorId) return pool[i];
    }
    return null;
  }

  function restoreSavedConfiguration() {
    var saved;
    try {
      var raw = window.localStorage.getItem(saveKey);
      if (!raw) return false;
      saved = JSON.parse(raw);
    } catch (e) {
      removeSavedConfiguration(false);
      return false;
    }
    var productId = root.getAttribute('data-product-id') || '';
    if (!saved || saved.version !== saveVersion || String(saved.productId || '') !== String(productId) ||
        !saved.expiresAt || Number(saved.expiresAt) <= Date.now() ||
        (saved.mode !== 'guided' && saved.mode !== 'advanced')) {
      removeSavedConfiguration(false);
      return false;
    }
    var savedIds = [
      saved.material, saved.finish, saved.color, saved.advancedLine,
      saved.advancedColor, saved.threadStyle, saved.threadColor, saved.foam
    ];
    for (var sid = 0; sid < savedIds.length; sid++) {
      if (savedIds[sid] && !/^[a-z0-9-]+$/i.test(String(savedIds[sid]))) {
        removeSavedConfiguration(false);
        return false;
      }
    }

    var matTile = null;
    var finish = null;
    var color = null;
    var line = null;
    var advancedColor = null;
    if (saved.mode === 'guided') {
      matTile = root.querySelector('[data-step-id="material-family"] [data-material="' + String(saved.material || '') + '"]');
      var entry = saved.material && catalog[saved.material];
      if (!matTile || !entry || !variantMap[saved.material]) {
        removeSavedConfiguration(false);
        return false;
      }
      if (saved.finish) {
        var finishes = entry.finishes || [];
        for (var fi = 0; fi < finishes.length; fi++) {
          if (finishes[fi].id === saved.finish) { finish = finishes[fi]; break; }
        }
        if (!finish) { removeSavedConfiguration(false); return false; }
      }
      if (saved.color) {
        color = guidedColorFromSaved(entry, saved.finish, saved.color);
        if (!color) { removeSavedConfiguration(false); return false; }
      }
    } else {
      line = findAdvancedLine(saved.advancedLine);
      if (!line) { removeSavedConfiguration(false); return false; }
      if (saved.advancedColor) {
        for (var ac = 0; ac < (line.colors || []).length; ac++) {
          if (line.colors[ac].id === saved.advancedColor) { advancedColor = line.colors[ac]; break; }
        }
        if (!advancedColor) { removeSavedConfiguration(false); return false; }
      }
    }

    var threadTile = root.querySelector('[data-thread-style="' + String(saved.threadStyle || '') + '"]');
    var threadColor = threadColorFromSaved(saved.threadStyle, saved.threadColor);
    if (!threadTile || (saved.threadColor && saved.threadStyle !== 'match-material' && !threadColor)) {
      removeSavedConfiguration(false);
      return false;
    }
    var foamTile = root.querySelector('[data-foam="' + String(saved.foam || '') + '"]');
    if (!foamTile) { removeSavedConfiguration(false); return false; }

    state.mode = saved.mode;
    root.setAttribute('data-mode', state.mode);
    if (advPanel) {
      if (state.mode === 'advanced') advPanel.removeAttribute('hidden');
      else advPanel.setAttribute('hidden', '');
    }

    if (state.mode === 'guided') {
      state.material = saved.material;
      state.materialLabel = matTile.getAttribute('data-material-label');
      state.upcharge = 0;
      state.finish = finish ? finish.id : null;
      state.finishLabel = finish ? finish.label : null;
      state.color = color ? color.id : null;
      state.colorLabel = color ? color.label : null;
      matTile.setAttribute('aria-checked', 'true');
      syncVariantId();
    } else {
      state.advancedLine = line.id;
      state.advancedLineLabel = line.label;
      state.advancedLineUpcharge = Number(line.upcharge || 0);
      state.advancedColor = advancedColor ? advancedColor.id : null;
      state.advancedColorLabel = advancedColor ? advancedColor.label : null;
      if (advLineSelect) advLineSelect.value = line.id;
      if (advLineMetaEl) {
        advLineMetaEl.textContent = line.desc + ' \u00b7 + $' + state.advancedLineUpcharge.toFixed(0) + ' per panel';
        advLineMetaEl.classList.add('is-active');
      }
    }

    state.threadStyle = saved.threadStyle;
    state.threadStyleLabel = threadTile.getAttribute('data-thread-style-label');
    state.threadColor = threadColor ? threadColor.id : null;
    state.threadColorLabel = threadColor ? threadColor.label : null;
    state.threadColorHex = threadColor ? threadColor.hex : null;
    Array.prototype.forEach.call(threadStyleTiles, function (tile) {
      tile.setAttribute('aria-checked', tile === threadTile ? 'true' : 'false');
    });

    state.foam = saved.foam;
    state.foamLabel = foamTile.getAttribute('data-foam-label');
    Array.prototype.forEach.call(foamTiles, function (tile) {
      tile.setAttribute('aria-checked', tile === foamTile ? 'true' : 'false');
    });

    state.qty = Math.max(1, Math.min(99, parseInt(saved.qty, 10) || 1));
    state.vinylUpsellWanted = !!saved.vinylUpsellWanted;
    state.threadUpsellWanted = !!saved.threadUpsellWanted;
    if (qtyInput) qtyInput.value = String(state.qty);

    renderFinishesForMaterial();
    if (finishGridEl && state.finish) {
      var restoredFinishTile = finishGridEl.querySelector('[data-finish="' + state.finish + '"]');
      if (restoredFinishTile) restoredFinishTile.setAttribute('aria-checked', 'true');
      var presetTile = root.querySelector('[data-step-id="material-family"] [data-material="' + state.material + '"][data-preset-finish="' + state.finish + '"]');
      if (presetTile) {
        Array.prototype.forEach.call(root.querySelectorAll('[data-step-id="material-family"] [data-material]'), function (t) { t.setAttribute('aria-checked', 'false'); });
        presetTile.setAttribute('aria-checked', 'true');
        if (presetTile.closest('[data-cnc-more-grid]') && root.cncOpenMore) root.cncOpenMore();
        applyPresetFinish(state.finish);
      }
    }
    renderColorsForFinish();
    if (colorGridEl) {
      var restoredColorId = state.mode === 'advanced' ? state.advancedColor : state.color;
      var restoredColorTile = restoredColorId && colorGridEl.querySelector('[data-color="' + restoredColorId + '"]');
      if (restoredColorTile) restoredColorTile.setAttribute('aria-checked', 'true');
    }
    renderThreadColorArea();
    if (threadColorGridEl && state.threadColor) {
      var restoredThreadTile = threadColorGridEl.querySelector('[data-thread-color="' + state.threadColor + '"]');
      if (restoredThreadTile) restoredThreadTile.setAttribute('aria-checked', 'true');
    }
    Array.prototype.forEach.call(vinylUpsellChoices, function (choice) {
      choice.checked = choice.value === (state.vinylUpsellWanted ? 'add' : 'skip');
    });
    Array.prototype.forEach.call(threadUpsellChoices, function (choice) {
      choice.checked = choice.value === (state.threadUpsellWanted ? 'add' : 'skip');
    });
    if (upsellYardEl && saved.yardage) {
      var restoredYardage = Math.max(1, Math.min(5, parseInt(saved.yardage, 10) || 1));
      upsellYardEl.value = String(restoredYardage);
      yardageManuallySet = true;
    }
    if (clearSavedEl) clearSavedEl.removeAttribute('hidden');
    if (saveStatusEl) saveStatusEl.textContent = 'Your saved choices were restored. Notes are never stored.';
    fireConfiguratorEvent('cnc_config_restored');
    return true;
  }

  /* ==================================================================
     Review panel, validation, line item properties
     ================================================================== */

  /* Format the thread line for the review/cart property.
     Customer-facing: just the color name (key is already "Thread").
     e.g. review row renders as "Thread: Sunflower Gold". */
  function threadReviewText() {
    if (!state.threadStyle) return null;
    if (state.threadStyle === 'match-material') return 'Carolyn Fabrics will match by eye';
    if (state.threadColorLabel) return state.threadColorLabel;
    return '(pending color)';
  }

  /* Compute the ordered list of {key,value} rows for both the review
     panel and the cart line item properties. Empty / not-applicable
     rows are omitted here so both outputs share the same logic. */
  function buildReviewRows() {
    var rows = [];
    var mat = currentMaterialLabel();
    if (mat) rows.push({ key: 'Material', value: mat });
    if (state.mode === 'guided' && state.finishLabel) {
      rows.push({ key: 'Finish & Texture', value: state.finishLabel });
    }
    var col = currentColorLabel();
    if (col) rows.push({ key: 'Color', value: col });
    if (state.threadStyle) rows.push({ key: 'Thread', value: threadReviewText() });
    if (state.foamLabel) rows.push({ key: 'Foam', value: state.foamLabel });
    rows.push({ key: 'Quantity', value: String(state.qty || 1) });
    var upcharge = currentUpcharge();
    var perPanel = basePrice + upcharge;
    rows.push({ key: 'Per panel', value: fmt(perPanel) });
    var panelSub = perPanel * (state.qty || 1);
    /* Preserve original Subtotal row semantics so existing tests and
       cart behavior stay identical; add-on rows are additive below. */
    if ((state.qty || 1) > 1) {
      rows.push({ key: 'Subtotal', value: fmt(panelSub) });
    }
    var vSub = vinylSubtotalActive();
    if (vSub > 0) {
      rows.push({
        key: 'Matching vinyl (' + getYardage() + ' yd)',
        value: fmt(vSub)
      });
    }
    var tSub = threadSubtotalActive();
    if (tSub > 0) {
      rows.push({ key: 'Matching thread', value: fmt(tSub) });
    }
    if (vSub > 0 || tSub > 0) {
      rows.push({ key: 'Estimated total', value: fmt(panelSub + vSub + tSub) });
    }
    if (state.notes && state.notes.trim()) {
      rows.push({ key: 'Notes', value: state.notes.trim() });
    }
    if (state.customRequest && state.customRequest.trim()) {
      rows.push({ key: 'Custom Request', value: state.customRequest.trim() });
    }
    return rows;
  }

  function renderReview() {
    if (!reviewListEl) return;
    var rows = buildReviewRows();
    reviewListEl.innerHTML = '';
    /* Require at least a material before the review reads as "started" */
    var started = hasAnyMaterialSelected();
    if (!started) {
      if (reviewEmptyEl) reviewEmptyEl.style.display = 'block';
      reviewListEl.setAttribute('hidden', '');
      return;
    }
    if (reviewEmptyEl) reviewEmptyEl.style.display = 'none';
    reviewListEl.removeAttribute('hidden');
    for (var i = 0; i < rows.length; i++) {
      var dt = document.createElement('dt');
      dt.className = 'cnc-cfg__review-key';
      dt.textContent = rows[i].key;
      var dd = document.createElement('dd');
      dd.className = 'cnc-cfg__review-val';
      dd.textContent = rows[i].value;
      reviewListEl.appendChild(dt);
      reviewListEl.appendChild(dd);
    }
  }

  /* ================================================================
     Pricing-integrity guard (added 2026-06-06)
     The cart charges whatever Shopify variant the form posts. Each
     guided material MUST resolve to its priced variant through
     variantMap, which the section prints as <script data-cnc-variant-map>.
     If that block is ever dropped (it has been, twice) variantMap is
     empty and the form keeps the default = cheapest variant. We must
     NEVER silently fall through to base pricing — that under-charged
     orders #2009 and #2064. So: if a chosen material can't resolve to a
     distinct priced variant, we BLOCK add-to-cart and surface an error.
     ================================================================ */
  function variantMapEmpty() {
    for (var k in variantMap) {
      if (Object.prototype.hasOwnProperty.call(variantMap, k)) return false;
    }
    return true;
  }
  function panelVariantOk() {
    /* Advanced mode prices via the upsell line, not the material map. */
    if (state.mode === 'advanced') return true;
    /* No material chosen yet is not a pricing fault (isValid handles it). */
    if (!state.material) return true;
    if (variantMapEmpty()) return false;
    var entry = variantMap[state.material];
    if (!entry || !entry.id) return false;
    /* Force the form to the resolved priced variant and confirm it took. */
    var input = root.querySelector('[data-cnc-form] input[name="id"]');
    if (input) input.value = entry.id;
    return !!input && String(input.value) === String(entry.id);
  }

  /* Is the current configuration complete enough to add to cart? Returns
     { ok: bool, missing: [labels] } so the hint can explain what's left. */
  function isValid() {
    var missing = [];
    if (!hasAnyMaterialSelected())   missing.push('material');
    if (!currentColorLabel())        missing.push('color');
    if (!state.threadStyle)          missing.push('thread style');
    else if (state.threadStyle !== 'match-material' && !state.threadColor) missing.push('thread color');
    if (!state.foam)                 missing.push('foam');
    var q = parseInt(state.qty, 10);
    if (isNaN(q) || q < 1)           missing.push('quantity');
    return { ok: missing.length === 0, missing: missing };
  }

  function updateValidity() {
    var v = isValid();
    var pricingBroken = !panelVariantOk();
    var ok = v.ok && !pricingBroken;
    if (ctaBtnEl) {
      if (ok) ctaBtnEl.removeAttribute('disabled');
      else    ctaBtnEl.setAttribute('disabled', '');
    }
    if (ctaHintEl) {
      if (pricingBroken) {
        ctaHintEl.textContent = 'Online pricing is temporarily unavailable for this option \u2014 please contact us before ordering so we can confirm the correct price.';
        if (ctaHintEl.classList) ctaHintEl.classList.add('cnc-cfg__cta-hint--error');
        console.error('[CNC] Pricing guard: material "' + state.material + '" did not resolve to a priced variant. Add-to-cart BLOCKED to prevent undercharge. Check the data-cnc-variant-map block in sections/cnc-configurator.liquid.');
      } else if (v.ok) {
        ctaHintEl.textContent = 'Ready to add to cart.';
        if (ctaHintEl.classList) ctaHintEl.classList.remove('cnc-cfg__cta-hint--error');
      } else {
        ctaHintEl.textContent = 'Still needed: ' + v.missing.join(', ') + '.';
        if (ctaHintEl.classList) ctaHintEl.classList.remove('cnc-cfg__cta-hint--error');
      }
    }
  }

  /* Rebuild the hidden <input name="properties[...]"> set so the
     standard Shopify cart form always carries the current configuration.
     Only valid, populated fields are emitted — no empty rows in cart. */
  function syncFormProperties() {
    if (!formPropsEl) return;
    formPropsEl.innerHTML = '';
    if (formQtyEl) formQtyEl.value = String(state.qty || 1);
    /* Don't emit any line item properties until configuration begins —
       keeps the cart form mirror consistent with the review card. */
    if (!hasAnyMaterialSelected()) return;
    var rows = buildReviewRows();
    /* Per-panel / Subtotal / Quantity are already shown by the cart line
       itself (Shopify has qty + price natively), so we skip those here. */
    var skipKeys = { 'Per panel': 1, 'Subtotal': 1, 'Quantity': 1,
                     'Matching thread': 1, 'Estimated total': 1 };
    for (var i = 0; i < rows.length; i++) {
      /* Skip any "Matching vinyl (N yd)" row — dynamic yardage key */
      if (/^Matching vinyl /.test(rows[i].key)) continue;
      if (skipKeys[rows[i].key]) continue;
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[' + rows[i].key + ']';
      inp.value = rows[i].value;
      formPropsEl.appendChild(inp);
    }
  }

  /* ==================================================================
     Live preview (lightweight SVG)

     Three knobs:
       - Material color  -> background rect fill
       - Thread color    -> stitch lines + border stroke
       - "Pattern"       -> the diamond stitch grid (fixed shape for now;
                            becomes per-pattern later when real pattern
                            data ships with the product)

     The stitch grid is generated once at boot and lives in the DOM so
     per-change updates are just two setAttribute calls. No RAF, no
     debounce, no extra paints.
     ================================================================== */
  var DEFAULT_MATERIAL_FILL = '#4a4a4a';
  var DEFAULT_THREAD_STROKE = '#efece4';

  function buildStitchPattern() {
    if (!previewStitchEl) return;
    previewStitchEl.innerHTML = '';
    var w = 500, h = 300;
    /* Diamond grid — rhombus tiles 50 wide, 40 tall */
    var tileW = 50, tileH = 40;
    var lines = [];
    for (var y = 0; y <= h + tileH; y += tileH) {
      for (var x = 0; x <= w + tileW; x += tileW) {
        var cx = x + (y % (tileH * 2) === 0 ? 0 : tileW / 2);
        var top    = [cx,             y - tileH / 2];
        var right  = [cx + tileW / 2, y];
        var bottom = [cx,             y + tileH / 2];
        var left   = [cx - tileW / 2, y];
        lines.push([top, right]);
        lines.push([right, bottom]);
        lines.push([bottom, left]);
        lines.push([left, top]);
      }
    }
    /* Dedup: each internal edge is drawn twice. Use key by rounded coords. */
    var seen = {};
    var svgNS = 'http://www.w3.org/2000/svg';
    var frag = document.createDocumentFragment();
    for (var i = 0; i < lines.length; i++) {
      var a = lines[i][0], b = lines[i][1];
      /* Clip to viewBox loosely */
      if ((a[0] < -5 && b[0] < -5) || (a[0] > w + 5 && b[0] > w + 5)) continue;
      if ((a[1] < -5 && b[1] < -5) || (a[1] > h + 5 && b[1] > h + 5)) continue;
      var k = Math.round(Math.min(a[0], b[0])) + ',' + Math.round(Math.min(a[1], b[1])) + '-' +
              Math.round(Math.max(a[0], b[0])) + ',' + Math.round(Math.max(a[1], b[1]));
      if (seen[k]) continue;
      seen[k] = 1;
      var line = document.createElementNS(svgNS, 'line');
      line.setAttribute('x1', a[0]);
      line.setAttribute('y1', a[1]);
      line.setAttribute('x2', b[0]);
      line.setAttribute('y2', b[1]);
      frag.appendChild(line);
    }
    previewStitchEl.appendChild(frag);
  }

  /* Rough luminance — used to pick a caption text color and to nudge
     very dark materials to a brighter thread fallback. */
  function luminance(hex) {
    var rgb = hexToRgb(hex);
    if (!rgb) return 0.5;
    return (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
  }

  /* Inline pattern SVG — fetches the real product pattern SVG, tags its
     background rect + stroked elements, and replaces the <img> overlay
     so renderPreview() can tint it live. renderPreview() re-queries the
     tagged elements every paint so there are no stale references. */
  function loadInlinePatternSVG() {
    /* B4A: inline the pattern SVG into EVERY preview frame (full preview +
       compact mobile mirror) from a SINGLE fetch, so all previews share one
       source geometry and can never drift out of sync. */
    var frames = root.querySelectorAll('[data-cnc-preview-frame]');
    if (!frames.length) return;
    var src = null;
    for (var fi = 0; fi < frames.length; fi++) {
      var im0 = frames[fi].querySelector('.cnc-cfg__preview-image');
      if (im0) { src = im0.getAttribute('src'); break; }
    }
    if (!src || !/\.svg(\?|$)/i.test(src)) return;
    if (src.indexOf('//') === 0) src = window.location.protocol + src;
    fetch(src, { credentials: 'omit', mode: 'cors' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('fetch ' + r.status)); })
      .then(function (txt) {
        for (var k = 0; k < frames.length; k++) {
          var imgEl = frames[k].querySelector('.cnc-cfg__preview-image');
          if (!imgEl) continue;
          var doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
          var svg = doc.documentElement;
          if (!svg || svg.nodeName.toLowerCase() !== 'svg') continue;
          svg.setAttribute('class', 'cnc-cfg__preview-inline');
          svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
          svg.removeAttribute('width');
          svg.removeAttribute('height');
          svg.setAttribute('aria-hidden', 'true');
          var bg = svg.querySelector('rect[fill]');
          if (bg) bg.setAttribute('data-pattern-bg', '');
          var stroked = svg.querySelectorAll('[stroke]');
          for (var i = 0; i < stroked.length; i++) stroked[i].setAttribute('data-pattern-stitches', '');
          imgEl.parentNode.replaceChild(svg, imgEl);
        }
        renderPreview();
      })
      .catch(function () { /* leave <img> fallback in place */ });
  }

  function renderPreview() {
    var matHex    = currentColorHex();
    var threadHex = state.threadColorHex;
    /* B4A: tint EVERY preview frame (full preview + compact mobile mirror)
       in the SAME paint. Re-query all tagged elements each call so every
       preview stays perfectly in sync — single state, single render, no
       drift between the full and compact previews. */
    var fill = matHex || DEFAULT_MATERIAL_FILL;
    var stroke = threadHex || DEFAULT_THREAD_STROKE;
    var bgEls = root.querySelectorAll('[data-preview-bg],[data-pattern-bg]');
    for (var bi = 0; bi < bgEls.length; bi++) bgEls[bi].setAttribute('fill', fill);
    var strokeEls = root.querySelectorAll('[data-preview-stitches],[data-preview-border],[data-pattern-stitches]');
    for (var si = 0; si < strokeEls.length; si++) strokeEls[si].setAttribute('stroke', stroke);

    /* Caption — lightweight explanation of what the preview shows */
    if (previewCapEl) {
      var mat = currentMaterialLabel();
      var col = currentColorLabel();
      var thr = state.threadColorLabel;
      if (!mat && !col) {
        previewCapEl.textContent = 'Select a material color to preview the panel.';
      } else {
        var parts = [];
        if (mat) parts.push(mat);
        if (col) parts.push(col);
        if (thr) parts.push('\u00b7 ' + thr + ' thread');
        if (thr && !threadHex) parts.push('(stitch preview is neutral; see thread photo)');
        previewCapEl.textContent = parts.join(' ');
      }
    }
  }

  /* ==================================================================
     Vinyl upsell — "Complete your project"

     Looks up the selected material + color in the vinyl mapping and,
     if a matching Shopify product/variant exists, shows the upsell
     section with a yardage dropdown. ATC then adds both the panel
     and the vinyl in one AJAX request.
     ================================================================== */

  /* Find the matching vinyl product for the current selection.
     Returns { handle, variant_id } or null. */
  function getVinylMatch() {
    var materialId = state.mode === 'advanced' ? null : state.material;
    if (!materialId) return null;
    var bucket = vinylMap[materialId];
    if (!bucket) return null;
    var colorLabel = currentColorLabel();
    if (!colorLabel) return null;
    var match = bucket[colorLabel];
    return match || null;
  }

  /* Default yardage suggestion based on panel quantity */
  function defaultYardage(qty) {
    if (qty <= 2) return '2';
    if (qty <= 5) return '3';
    return '5';
  }

  /* Track whether yardage was manually changed — if so, don't override
     the customer's choice when qty changes. */
  var yardageManuallySet = false;

  function getYardage() {
    /* When the customer hasn't manually chosen yardage, return the default
       for the current panel qty directly. This keeps every surface
       (review list + estimate block) in agreement regardless of the order
       in which they render vs. renderUpsell() normalizing the <select>. */
    if (!yardageManuallySet) {
      var dq = parseInt(state.qty, 10);
      if (isNaN(dq) || dq < 1) dq = 1;
      return parseInt(defaultYardage(dq), 10);
    }
    var y = upsellYardEl ? parseInt(upsellYardEl.value, 10) : 2;
    if (isNaN(y) || y < 1) y = 2;
    if (y > 5) y = 5;
    return y;
  }
  function vinylPricePerYard() {
    var m = getVinylMatch();
    if (!m || typeof m.price !== 'number') return 0;
    return (typeof m.roll_price === 'number' && m.roll_price > 0 && m.roll_price < m.price) ? m.roll_price : m.price;
  }
  function vinylSubtotalActive() {
    /* $$ added to cart iff wanted AND a mapped match exists */
    if (!state.vinylUpsellWanted) return 0;
    var m = getVinylMatch();
    if (!m) return 0;
    return vinylPricePerYard() * getYardage();
  }

  /* Preserve the existing offer copy for discounted lines. Spirit is not
     enrolled in the matching-roll discount and uses its current yard price. */
  var vinylOfferTitle = upsellEl && upsellEl.querySelector('.cnc-cfg__upsell-title');
  var vinylOfferCopy = upsellEl && upsellEl.querySelector('.cnc-cfg__upsell-subtext');
  var originalVinylOfferTitle = vinylOfferTitle ? vinylOfferTitle.textContent : '';
  var originalVinylOfferCopy = vinylOfferCopy ? vinylOfferCopy.innerHTML : '';

  function renderUpsell() {
    if (!upsellEl) return;
    var match = getVinylMatch();
    if (!match) {
      upsellEl.setAttribute('hidden', '');
      return;
    }
    upsellEl.removeAttribute('hidden');
    var isSpirit = match.handle === 'spirit-millennium';
    if (vinylOfferTitle) vinylOfferTitle.textContent = isSpirit ? 'Add matching Spirit Millennium vinyl' : originalVinylOfferTitle;
    if (vinylOfferCopy) {
      if (isSpirit) vinylOfferCopy.textContent = 'Add matching Spirit Millennium yardage at its regular by-the-yard price. Most projects need extra for wrapping edges and surrounding upholstery.';
      else vinylOfferCopy.innerHTML = originalVinylOfferCopy;
    }
    var matLabel = currentMaterialLabel() || '';
    var colLabel = currentColorLabel() || '';
    if (upsellDescEl) {
      upsellDescEl.textContent = 'Add matching vinyl \u2013 ' + matLabel + ' / ' + colLabel;
    }
    /* Set default yardage if user hasn't manually picked */
    if (upsellYardEl && !yardageManuallySet) {
      upsellYardEl.value = defaultYardage(state.qty || 1);
    }
    /* Price per yard display (next to yardage) */
    var pp = vinylPricePerYard();
    var reg = (match && typeof match.price === 'number') ? match.price : 0;
    var savePerYd = (reg > pp && pp > 0) ? (reg - pp) : 0;
    if (upsellPriceEl) {
      upsellPriceEl.textContent = pp > 0 ? fmt(pp) + ' / yard' : '';
    }
    if (upsellRegEl) {
      if (savePerYd > 0) { upsellRegEl.textContent = 'reg. ' + fmt(reg) + ' / yard'; upsellRegEl.removeAttribute('hidden'); }
      else upsellRegEl.setAttribute('hidden', '');
    }
    if (upsellSaveEl) {
      if (savePerYd > 0) { upsellSaveEl.textContent = 'Roll price \u2014 save ' + fmt(savePerYd) + ' / yard'; upsellSaveEl.removeAttribute('hidden'); }
      else upsellSaveEl.setAttribute('hidden', '');
    }
    /* Gray out controls + subtotal line when user has opted out */
    var on = state.vinylUpsellWanted;
    if (upsellCtrlEl) {
      if (on) upsellCtrlEl.removeAttribute('data-disabled');
      else    upsellCtrlEl.setAttribute('data-disabled', '');
    }
    if (upsellYardEl) upsellYardEl.disabled = !on;
    if (upsellLineEl && upsellSubEl) {
      if (on && pp > 0) {
        upsellLineEl.removeAttribute('hidden');
        upsellSubEl.textContent = fmt(pp * getYardage());
        if (upsellSavedEl) {
          if (savePerYd > 0) { upsellSavedEl.textContent = '\u00b7 you save ' + fmt(savePerYd * getYardage()); upsellSavedEl.removeAttribute('hidden'); }
          else upsellSavedEl.setAttribute('hidden', '');
        }
      } else {
        if (upsellSavedEl) upsellSavedEl.setAttribute('hidden', '');
        upsellLineEl.setAttribute('hidden', '');
      }
    }
  }

  if (upsellYardEl) {
    /* Mark manual override on both input and change — some browsers /
       synthetic event dispatches fire one before the other, and we must
       not re-apply the default after the user has picked a yardage. */
    upsellYardEl.addEventListener('change', function () { yardageManuallySet = true; });
    upsellYardEl.addEventListener('input',  function () { yardageManuallySet = true; });
  }

  /* Thread upsell lookup — returns { handle, variant_id, price? } or null.
     Safely returns null if mapping is missing so we never break cart add. */
  function getThreadMatch() {
    /* Batch 7A: the matching spool is color-agnostic — CF matches the color
       by eye — so it is available for BOTH match-by-eye and named-color
       stitch choices and must never be gated on threadColorLabel. */
    if (!cncMatchSpool || !cncMatchSpool.variant_id) return null;
    return cncMatchSpool;
  }
  function threadPrice() {
    var m = getThreadMatch();
    if (!m || typeof m.price !== 'number') return 0;
    return m.price;
  }
  function threadSubtotalActive() {
    if (!state.threadUpsellWanted) return 0;
    return threadPrice();
  }

  function renderThreadUpsell() {
    if (!threadUpsellEl) return;
    /* Only show when the main vinyl upsell is showing (same context),
       a thread color is picked, AND a mapping entry exists. Until the
       mapping is populated, this block stays hidden. */
    var vinylVisible = upsellEl && !upsellEl.hasAttribute('hidden');
    var threadMatch  = getThreadMatch();
    if (!vinylVisible || !threadMatch) {
      threadUpsellEl.setAttribute('hidden', '');
      return;
    }
    threadUpsellEl.removeAttribute('hidden');
    if (threadUpsellSubEl) {
      threadUpsellSubEl.textContent =
        'Amann OutdoorPro Tex 135 \u2014 Carolyn Fabrics matches the spool color to your panel by eye.';
    }
    var tp = threadPrice();
    if (threadUpsellLineEl && threadUpsellPriceEl) {
      if (state.threadUpsellWanted && tp > 0) {
        threadUpsellLineEl.removeAttribute('hidden');
        threadUpsellPriceEl.textContent = fmt(tp);
      } else {
        threadUpsellLineEl.setAttribute('hidden', '');
      }
    }
  }

  for (var ti = 0; ti < threadUpsellChoices.length; ti++) {
    threadUpsellChoices[ti].addEventListener('change', function (e) {
      state.threadUpsellWanted = (e.target.value === 'add');
      reactPhase9();
    });
  }
  for (var vi = 0; vi < vinylUpsellChoices.length; vi++) {
    vinylUpsellChoices[vi].addEventListener('change', function (e) {
      state.vinylUpsellWanted = (e.target.value === 'add');
      reactPhase9();
    });
  }

  /* Vinyl yardage already has a change listener above; extend it to
     trigger reactive updates so subtotal + total stay live. */
  if (upsellYardEl) {
    upsellYardEl.addEventListener('change', function () { reactPhase9(); });
    upsellYardEl.addEventListener('input',  function () { reactPhase9(); });
  }

  /* ==================================================================
     Estimated Total — panel subtotal + (vinyl if on) + (thread if on)
     ================================================================== */
  function panelSubtotal() {
    var upcharge = currentUpcharge();
    var perPanel = basePrice + upcharge;
    var qty = Math.max(1, parseInt(state.qty, 10) || 1);
    return perPanel * qty;
  }
  function renderEstimatedTotal() {
    if (!estimatedTotalEl) return;
    if (!hasAnyMaterialSelected()) {
      estimatedTotalEl.setAttribute('hidden', '');
      return;
    }
    estimatedTotalEl.removeAttribute('hidden');

    var p = panelSubtotal();
    if (estPanelEl) estPanelEl.textContent = fmt(p);

    var vinylOn  = state.vinylUpsellWanted && !!getVinylMatch();
    var vSub     = vinylSubtotalActive();
    if (estVinylRowEl) {
      if (vinylOn && vSub > 0) {
        estVinylRowEl.removeAttribute('hidden');
        if (estVinylLabelEl) {
          estVinylLabelEl.textContent = 'Matching vinyl (' + getYardage() + ' yd)';
        }
        if (estVinylEl) estVinylEl.textContent = fmt(vSub);
      } else {
        estVinylRowEl.setAttribute('hidden', '');
        if (estVinylLabelEl) estVinylLabelEl.textContent = 'Matching vinyl';
        if (estVinylEl) estVinylEl.textContent = '\u2014';
      }
    }

    var threadOn = state.threadUpsellWanted && !!getThreadMatch();
    var tSub     = threadSubtotalActive();
    if (estThreadRowEl) {
      if (threadOn && tSub > 0) {
        estThreadRowEl.removeAttribute('hidden');
        if (estThreadEl) estThreadEl.textContent = fmt(tSub);
      } else {
        estThreadRowEl.setAttribute('hidden', '');
        if (estThreadEl) estThreadEl.textContent = '\u2014';
      }
    }

    if (estTotalEl) estTotalEl.textContent = fmt(p + vSub + tSub);
  }

  /* Single reactive call that runs on every state change. Cheap enough
     to run unconditionally — the DOM writes are small. */
  function reactPhase9() {
    renderReview();
    syncFormProperties();
    updateValidity();
    renderPreview();
    renderUpsell();
    renderThreadUpsell();
    renderEstimatedTotal();
    persistConfiguration();
  }

  /* Wrap the core update functions so every existing handler
     automatically triggers reactive updates without editing each one. */
  var _updateSummary     = updateSummary;
  var _updatePriceDisplay = updatePriceDisplay;
  updateSummary = function () {
    _updateSummary.apply(null, arguments);
    reactPhase9();
  };
  updatePriceDisplay = function () {
    _updatePriceDisplay.apply(null, arguments);
    reactPhase9();
  };

  /* ==================================================================
     ATC override — dual-item AJAX cart add

     When a vinyl upsell match is present, the form submit is
     intercepted and replaced with a single /cart/add.js POST
     containing both the CNC panel and the matching vinyl yardage.
     When there's no upsell match, the form posts normally.
     ================================================================== */
  var formEl = root.querySelector('[data-cnc-form]');
  if (formEl) {
    formEl.addEventListener('submit', function (e) {
      /* Pricing-integrity hard stop: never post a panel whose material
         did not resolve to its priced variant (prevents the silent
         base-price undercharge that hit #2009 + #2064). */
      if (!panelVariantOk()) {
        e.preventDefault();
        console.error('[CNC] Blocked add-to-cart: panel variant did not resolve to a priced variant (data-cnc-variant-map missing/broken).');
        if (ctaHintEl) {
          ctaHintEl.textContent = 'Online pricing is temporarily unavailable for this option \u2014 please contact us before ordering so we can confirm the correct price.';
          if (ctaHintEl.classList) ctaHintEl.classList.add('cnc-cfg__cta-hint--error');
        }
        if (ctaBtnEl) ctaBtnEl.setAttribute('disabled', '');
        return;
      }
      var vinylMatch  = state.vinylUpsellWanted  ? getVinylMatch()  : null;
      var threadMatch = state.threadUpsellWanted ? getThreadMatch() : null;
      /* No upsell of any kind → let the standard form submit proceed. */
      if (!vinylMatch && !threadMatch) {
        removeSavedConfiguration(false);
        return;
      }

      e.preventDefault();
      if (ctaBtnEl) {
        ctaBtnEl.setAttribute('disabled', '');
        ctaBtnEl.textContent = 'Adding\u2026';
      }

      /* Build the panel item from the existing form inputs */
      var panelVariant = formEl.querySelector('input[name="id"]');
      var panelQty     = formEl.querySelector('input[name="quantity"]');
      var panelItem = {
        id: parseInt(panelVariant ? panelVariant.value : '0', 10),
        quantity: parseInt(panelQty ? panelQty.value : '1', 10),
        properties: {}
      };
      /* Gather line item properties */
      var propInputs = formEl.querySelectorAll('[data-form-properties] input');
      for (var i = 0; i < propInputs.length; i++) {
        var n = propInputs[i].name;
        var match = n.match(/^properties\[(.+)\]$/);
        if (match) panelItem.properties[match[1]] = propInputs[i].value;
      }

      /* Assemble cart payload: panel + (optional) vinyl + (optional) thread */
      var items = [panelItem];
      if (vinylMatch) {
        /* Use getYardage() — the single source of truth also used by the
           review + estimate surfaces — so the cart quantity always matches
           the displayed matching-vinyl subtotal (no cart/display desync). */
        var yardage = getYardage();
        items.push({ id: vinylMatch.variant_id, quantity: yardage });
      }
      if (threadMatch) {
        /* Record which panel this optional matching spool is for, so the
           order line reads e.g. "Matching thread for: Beehive — Pinnacle 98 Charcoal". */
        var patternEl   = root.querySelector('[data-summary="pattern"]');
        var patternName = patternEl ? patternEl.textContent.trim() : '';
        var matLine     = (state.mode === 'advanced') ? state.advancedLineLabel : (state.finishLabel || state.materialLabel);
        var matColor    = currentColorLabel();
        var matDesc     = [matLine, matColor].filter(Boolean).join(' ');
        var matchingFor = [patternName, matDesc].filter(Boolean).join(' \u2014 ');
        var threadItem  = { id: threadMatch.variant_id, quantity: 1, properties: {} };
        if (matchingFor) threadItem.properties['Matching thread for'] = matchingFor;
        /* Record the stitch intent. By-eye is the default; named colors are
           still recorded, but the spool variant itself is color-agnostic. */
        threadItem.properties['Color selection'] = (state.threadStyle === 'match-material')
          ? 'Carolyn Fabrics will match by eye'
          : (state.threadColorLabel || 'Carolyn Fabrics will match by eye');
        items.push(threadItem);
      }

      /* POST all items to /cart/add.js */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (resp) {
        if (!resp.ok) {
          return resp.text().then(function (t) {
            throw new Error('Cart error ' + resp.status + ': ' + t.slice(0, 200));
          });
        }
        /* Success — redirect to cart */
        removeSavedConfiguration(false);
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('[CNC Upsell] Cart add failed:', err);
        /* Re-enable the button so customer can retry or fall back */
        if (ctaBtnEl) {
          ctaBtnEl.removeAttribute('disabled');
          ctaBtnEl.textContent = 'Add Panel to Cart';
        }
        if (ctaHintEl) {
          ctaHintEl.textContent = 'Nothing was added. Please retry, or choose “No thanks” for an extra and try again.';
          if (ctaHintEl.classList) ctaHintEl.classList.add('cnc-cfg__cta-hint--error');
        }
      });
    });
  }

  /* ---------- B7B Part 3: hide compact mobile preview at the review step ----------
     At mobile widths the sticky mini-preview must not cover the Review &
     Add-to-Cart area. Toggle a hide class on the mini when the review step
     enters the viewport; it returns when the customer scrolls back up. */
  (function initMiniReviewHide() {
    var miniEl = root.querySelector('[data-cnc-mini]');
    var reviewEl = root.querySelector('[data-step-id="review"]');
    if (!miniEl || !reviewEl || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          miniEl.classList.add('cnc-cfg__mini--at-review');
        } else {
          miniEl.classList.remove('cnc-cfg__mini--at-review');
        }
      });
    }, { root: null, threshold: 0 });
    io.observe(reviewEl);
  })();

  /* ---------- Initial paint ---------- */
  buildStitchPattern();
  loadInlinePatternSVG();
  populateAdvancedLineSelect();
  renderFinishesForMaterial();
  renderColorsForFinish();
  renderThreadColorArea();
  restoreSavedConfiguration();
  restoreComplete = true;
  /* Default to the recommended material (Pinnacle) when nothing is
     selected, so colors are on screen immediately. Silent: no scroll. */
  if (state.mode === 'guided' && !state.material) {
    var defaultTile = root.querySelector('[data-step-id="material-family"] [data-material][data-preset-finish="pinnacle-house"]');
    if (defaultTile) { suppressFlow = true; try { defaultTile.click(); } finally { suppressFlow = false; } }
  }
  renumberSteps();
  updateSummary();
  updatePriceDisplay();

})();

/* --- initialiser reached the end cleanly (added 2026-09-03) ---
   Paired with the watchdog at the top of this file. Do not remove one
   without the other. */
(function () {
  var root = document.querySelector('[data-cnc-cfg]');
  if (root && root.dataset.cncCfgInit === '1') root.dataset.cncCfgReady = '1';
})();
